
import Vue, { readonly } from 'vue';
import { GET_LEGAL_ENTITIES } from '@/gql';
import {
	ViewsBulkPayments_GetBulkPayments,
	ViewsBulkPayments_GetBulkPaymentsQueryVariables,
	ViewsBulkPayment_GetPaymentTransferConfiguration,
	ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables
} from '@/generated/graphql';
import axios from 'axios';

export default Vue.extend({
	data() {
		return {
			legalEntities: [],
			paymentTransferConfiguration: undefined,
			pamentTransferEnabled: true,
			paymentMinerEnabled: true,
			paymentExecutorEnabled: false,
			createdBulkPayments: [],
			excutedBulkPayments: [],
			loading: false,
			readonly: true
		};
	},
	created() {
		this.getLegalEntities();
	},
	methods: {
		async getLegalEntities() {
			let result = await this.$apollo.query({
				query: GET_LEGAL_ENTITIES,
				variables: {
					participant: this.$store.state.risolto.selectedParticipantStore
				}
			});
			this.legalEntities = result.data.legal_entities;
			if (this.legalEntities.length === 1) {
				this.selectedLegalEntity = this.legalEntities[0];
			}
			this.onSelectedLegalEntityChanged();
		},
		async onSelectedLegalEntityChanged() {
			if (this.selectedLegalEntity === undefined) {
				return;
			}

			this.loading = true;
			try {
				await this.getPaymentTransferConfiguration();
				await this.getBulkPayments();
			} finally {
				this.loading = false;
			}
		},
		async getPaymentTransferConfiguration() {
			if (this.selectedLegalEntity === undefined) {
				return;
			}

			let variables: ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables = {
				reference: this.selectedLegalEntity.reference,
				participant: this.$store.state.risolto.selectedParticipantStore
			};

			let result = await this.$apollo.query({
				query: ViewsBulkPayment_GetPaymentTransferConfiguration,
				variables: variables
			});

			this.paymentTransferConfiguration = result.data.legal_entity[0].payment_transfer_configuration;
			this.paymentTransferEnabled = this.paymentTransferConfiguration !== undefined; // TODO TEST

			if (this.paymentTransferEnabled) {
				this.paymentMinerEnabled = this.paymentTransferConfiguration.miner_enabled;
				this.paymentExecutorEnabled = this.paymentTransferConfiguration.executor_enabled;
			}
		},
		async getBulkPayments() {
			if (this.selectedLegalEntity === undefined) {
				return;
			}

			let variables: ViewsBulkPayments_GetBulkPaymentsQueryVariables = {
				legal_entity: this.selectedLegalEntity.reference,
				participant: this.$store.state.risolto.selectedParticipantStore
			};

			let result = await this.$apollo.query({
				query: ViewsBulkPayments_GetBulkPayments,
				variables: variables
			});

			this.createdBulkPayments = result.data.created;
			this.excutedBulkPayments = result.data.executed;
		},
		formatDate(row, column) {
			return new Date(row[column.property]).toLocaleDateString();
		},
		handleOpenDetailsClick(payment_transfer_reference: any) {
			this.$router.push({
				name: 'payment-transfer-details',
				params: {
					paymentTransfer: payment_transfer_reference,
					participant: this.$store.state.risolto.selectedParticipantStore,
					legalEntity: this.selectedLegalEntity.reference
				}
			});
		},
		handleOpenPaymentLink(row: any) {
			window.open(row.signing_link, '_blank');
		},
		determineBulkPaymentStatusDescription(row: any) {
			if (row.error_at !== null) {
				return this.$t('BulkPayments.StatusDescriptions.Error');
			} else if (row.finished_at !== null) {
				return this.$t('BulkPayments.StatusDescriptions.Finished');
			} else if (row.started_at !== null && row.finished_at === null) {
				return this.$t('BulkPayments.StatusDescriptions.Pending');
			} else {
				return this.$t('BulkPayments.StatusDescriptions.NotStarted');
			}
		}
	}
});
